
<template>
  <div>
    <el-form
      ref="entityData"
      :model="entityData"
      :rules="rules"
      label-width="100px"
      class="demo-ruleForm"
      label-position="right"
    >
      <el-row :gutter="20">
        <!-- 名称 -->

        <el-col :span="12">
          <el-form-item
            prop="mingCheng"
            label="名称"
          >
            <el-input
              v-model="entityData.mingCheng"
              clearable
            />
          </el-form-item>
        </el-col>

        <!-- 学科领域 -->

        <el-col :span="12">
          <el-form-item
            prop="xueKeLingYuDictKey"
            label="学科领域"
          >
            <Combox
              v-model="entityData.xueKeLingYuDictKey"
              type-id="D68"
              :option-data="getComboxData('D68')"
              :add-client="true"
            />
          </el-form-item>
        </el-col>

        <!-- 学科代码 -->

        <el-col :span="12">
          <el-form-item
            prop="xueKeDaiMa"
            label="学科代码"
          >
            <el-input
              v-model="entityData.xueKeDaiMa"
              clearable
            />
          </el-form-item>
        </el-col>

        <!-- 应用领域 -->

        <el-col :span="12">
          <el-form-item
            prop="yingYongLingYu"
            label="应用领域"
          >
            <el-input
              v-model="entityData.yingYongLingYu"
              clearable
            />
          </el-form-item>
        </el-col>

        <!-- 类别 -->

        <el-col :span="12">
          <el-form-item
            prop="leiBie"
            label="类别"
          >
            <el-input
              v-model="entityData.leiBie"
              clearable
            />
          </el-form-item>
        </el-col>

        <!-- 关键词 -->

        <el-col :span="12">
          <el-form-item
            prop="guanJianCi"
            label="关键词"
          >
            <el-input
              v-model="entityData.guanJianCi"
              clearable
            />
          </el-form-item>
        </el-col>

        <!-- 主要用途 -->

        <el-col :span="12">
          <el-form-item
            prop="zhuYaoYongTu"
            label="主要用途"
          >
            <el-input
              v-model="entityData.zhuYaoYongTu"
              clearable
            />
          </el-form-item>
        </el-col>

        <!-- 负责人 -->

        <el-col :span="12">
          <el-form-item
            prop="fuZeRen"
            label="负责人"
          >
            <el-input
              v-model="entityData.fuZeRen"
              clearable
            />
          </el-form-item>
        </el-col>

        <!-- 修订者 -->

        <el-col :span="12">
          <el-form-item
            prop="xiuDingZhe"
            label="修订者"
          >
            <el-input
              v-model="entityData.xiuDingZhe"
              clearable
            />
          </el-form-item>
        </el-col>

        <!-- 审定者 -->

        <el-col :span="12">
          <el-form-item
            prop="shengDingZhe"
            label="审定者"
          >
            <el-input
              v-model="entityData.shengDingZhe"
              clearable
            />
          </el-form-item>
        </el-col>

        <!-- 版本号 -->

        <el-col :span="12">
          <el-form-item
            prop="banBenHao"
            label="版本号"
          >
            <el-input
              v-model="entityData.banBenHao"
              clearable
            />
          </el-form-item>
        </el-col>

        <!-- 修订内容 -->

        <el-col :span="12">
          <el-form-item
            prop="xiuDingNeiRong"
            label="修订内容"
          >
            <el-input
              v-model="entityData.xiuDingNeiRong"
              clearable
            />
          </el-form-item>
        </el-col>

        <!-- 修订日期 -->
        <el-col :span="12">
          <el-form-item
            prop="xiuDingRiQi"
            label="修订日期"
          >
            <el-date-picker
              v-model="entityData.xiuDingRiQi"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              type="date"
              style="width: 100%;"
            />
          </el-form-item>
        </el-col>

        <!-- 总页数 -->

        <el-col :span="12">
          <el-form-item
            prop="totalPage"
            label="总页数"
          >
            <el-input-number
              v-model="entityData.totalPage"
            />
          </el-form-item>
        </el-col>

        <!-- 摘要 -->

        <el-col :span="12">
          <el-form-item
            prop="zhaiYao"
            label="摘要"
          >
            <el-input
              v-model="entityData.zhaiYao"
              clearable
            />
          </el-form-item>
        </el-col>

        <!-- 研究对象 -->

        <el-col :span="12">
          <el-form-item
            prop="yanJiuDuiXiang"
            label="研究对象"
          >
            <el-input
              v-model="entityData.yanJiuDuiXiang"
              clearable
            />
          </el-form-item>
        </el-col>

        <!-- 科研助理 -->

        <el-col :span="12">
          <el-form-item
            prop="keYanZhuLi"
            label="科研助理"
          >
            <el-input
              v-model="entityData.keYanZhuLi"
              clearable
            />
          </el-form-item>
        </el-col>

        <!-- 起草人 -->

        <el-col :span="12">
          <el-form-item
            prop="qiCaoRen"
            label="起草人"
          >
            <el-input
              v-model="entityData.qiCaoRen"
              clearable
            />
          </el-form-item>
        </el-col>

        <!-- 技术原理 -->

        <el-col :span="12">
          <el-form-item
            prop="jiShuYuanLi"
            label="技术原理"
          >
            <el-input
              v-model="entityData.jiShuYuanLi"
              clearable
            />
          </el-form-item>
        </el-col>

        <!-- 试剂试药 -->

        <el-col :span="12">
          <el-form-item
            prop="shiJiShiYao"
            label="试剂试药"
          >
            <el-input
              v-model="entityData.shiJiShiYao"
              clearable
            />
          </el-form-item>
        </el-col>

        <!-- 仪器名称及型号 -->

        <el-col :span="12">
          <el-form-item
            prop="yiQiMingCheng"
            label="仪器名称及型号"
          >
            <el-input
              v-model="entityData.yiQiMingCheng"
              clearable
            />
          </el-form-item>
        </el-col>

        <!-- 实验对象 -->

        <el-col :span="12">
          <el-form-item
            prop="shiYanDuiXiang"
            label="实验对象"
          >
            <el-input
              v-model="entityData.shiYanDuiXiang"
              clearable
            />
          </el-form-item>
        </el-col>

        <!-- 操作步骤 -->

        <el-col :span="12">
          <el-form-item
            prop="caoZuoBuZhou"
            label="操作步骤"
          >
            <el-input
              v-model="entityData.caoZuoBuZhou"
              clearable
            />
          </el-form-item>
        </el-col>

        <!-- 检测指标 -->

        <el-col :span="12">
          <el-form-item
            prop="jianCeZhiBiao"
            label="检测指标"
          >
            <el-input
              v-model="entityData.jianCeZhiBiao"
              clearable
            />
          </el-form-item>
        </el-col>

        <!-- 统计方法 -->

        <el-col :span="12">
          <el-form-item
            prop="tongJiFangFa"
            label="统计方法"
          >
            <el-input
              v-model="entityData.tongJiFangFa"
              clearable
            />
          </el-form-item>
        </el-col>

        <!-- 正常值及试验结果的评判与解释 -->

        <el-col :span="12">
          <el-form-item
            prop="jieGuo"
            label="正常值及试验结果的评判与解释"
          >
            <el-input
              v-model="entityData.jieGuo"
              clearable
            />
          </el-form-item>
        </el-col>

        <!-- 注意事项 -->

        <el-col :span="12">
          <el-form-item
            prop="zhuYiShiXiang"
            label="注意事项"
          >
            <el-input
              v-model="entityData.zhuYiShiXiang"
              clearable
            />
          </el-form-item>
        </el-col>

        <!-- 信息反馈 -->

        <el-col :span="12">
          <el-form-item
            prop="xinXiFanKui"
            label="信息反馈"
          >
            <el-input
              v-model="entityData.xinXiFanKui"
              clearable
            />
          </el-form-item>
        </el-col>

        <!-- 助理 -->
        <el-col :span="12">
          <el-form-item
            prop="assitantList"
            label="助理"
          >
            <AssistEditForm
              v-model="entityData.assitantList"
              module-code="jx02"
            />
          </el-form-item>
        </el-col>

      </el-row>
    </el-form>
    <div class="dialog-footer">
      <el-button
        v-if="ketiInfo.isFuzeren || ketiInfo.isZuli"
        type="primary"
        @click="handleSave()"
      >
        保  存
      </el-button>
    </div>
  </div>
</template>
<script>
import pathReq from '@/api/pathlist'
import Combox from '@/views/managesystem/gz/com/Combox'
import AssistEditForm from '@/views/managesystem/gz/com/AssistEditForm.vue'
export default {
  components: {
    Combox, AssistEditForm
  },
  props: {
    // postId: { type: Number, default: null }
  },
  data() {
    return {
      entityId: null,
      entityData: {},
      allComboxData: [],
      rules: {
        mingCheng: [
          { required: true, message: '请输入名称', trigger: 'change,blur' }
        ]
      },
      selectedValue: [],
      ketiInfo: {}
    }
  },
  computed: {},
  created() {
    /** 下拉框数据 */
    pathReq.getComboxDatasByIdArray('D68').then(res => {
      this.allComboxData = res.data.result
    })
  },
  activated() {
    this.init()
  },
  methods: {
    // combox筛选值
    getComboxData(typeId) {
      return this.allComboxData.filter(function(item) {
        return item.typeId === typeId
      })
    },
    /**
     * 初始化数据
     */
    init() {
      this.entityId = this.$route.params.id
      if (!this.entityId) {
        this.$router.go(-1)
        return
      }
      const path = '/api/services/app/ky09/GetEditky09?Id=' + this.entityId
      pathReq.getNoParams(path).then(res => {
        this.entityData = res.data.result.entityData
      }).then(_ => {
        pathReq.getKetiInfo('ky09', this.entityData.id).then(r => {
          this.ketiInfo = r.data.result
        })
      })
    },
    /**
     * 打开数据字典弹出框
     */
    handleAddComboxData(dictTypeId, dictTypeName) {
      this.$bus.emit('comboxData', dictTypeId, dictTypeName)
    },
    /**
     * 新增或者修改身份信息数据
     */
    handleSave() {
      this.$refs['entityData'].validate(valid => {
        if (valid) {
          const that = this
          const path = '/api/services/app/ky09/CreateOrUpdateky09'

          pathReq
            .postForm(path, { entityData: that.entityData })
            .then(res => {
              that.$message.success('保存成功')
            })
        }
      })
    }
  }
}
</script>
<style scoped>
.el-dialog__body {
  padding-top: 10px !important;
}

.dialog-footer {
  text-align: right;
}

.el-select {
  margin-right: 8px;
  width: 84% !important;
}
</style>
